import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 3,
    borderBottomLeftRadius: theme.spacing(0.625),
    borderBottomRightRadius: theme.spacing(0.625),
    backgroundColor: theme.palette.background.paper,
  },
});
